import React from "react";
import "./CloudDevOps.css";
import SEO from "../../SEO";
const cloudServices = [
  {
    title: "Cloud Infrastructure & Deployment",
    description:
      "MZR Software designs and manages secure, scalable cloud infrastructure using Microsoft Azure and modern DevOps practices. We deploy applications with high availability, load balancing, and automated scaling to ensure zero downtime and maximum performance.",
    features: [
      "Microsoft Azure",
      "Virtual Machines & App Services",
      "Azure SQL & Storage",
      "Load Balancing",
      "Auto Scaling",
      "Cloud Security Configuration",
    ],
    img: process.env.PUBLIC_URL + "/img/Cloud_Infrastructure_Deployment.gif",
    icon: "bi-cloud",
  },
  {
    title: "CI/CD Pipeline Automation",
    description:
      "At MZR Software, we implement Continuous Integration and Continuous Deployment pipelines using Azure DevOps and GitHub Actions. This allows automated build, testing, and deployment processes that reduce human errors and accelerate product releases.",
    features: [
      "Azure DevOps",
      "GitHub Actions",
      "Automated Builds",
      "Automated Testing",
      "Continuous Deployment",
      "Version Control (Git)",
    ],
    img: process.env.PUBLIC_URL + "/img/cicd.gif",
    icon: "bi-git",
  },
  {
    title: "Containerization & Microservices",
    description:
      "We use Docker and container-based architecture to package applications for consistent deployment across environments. Microservices architecture allows MZR Software to build scalable enterprise systems where each service runs independently and securely.",
    features: [
      "Docker",
      "Container Deployment",
      "Microservices Architecture",
      "API Gateway",
      "Scalable Services",
      "Environment Isolation",
    ],
    img: process.env.PUBLIC_URL + "/img/docker.gif",
    icon: "bi-box",
  },
  {
    title: "Monitoring & Performance Optimization",
    description:
      "MZR Software integrates real-time monitoring tools to track server health, application performance, and security threats. We proactively optimize performance and ensure system reliability using logging, alerts, and performance analytics.",
    features: [
      "Azure Monitor",
      "Application Insights",
      "Server Monitoring",
      "Log Management",
      "Performance Optimization",
      "Security Alerts",
    ],
    img: process.env.PUBLIC_URL + "/img/monitoring.gif",
    icon: "bi-activity",
  },
];

function CloudDevOps() {
  return (
    <>
      <SEO
        title="Cloud & DevOps Services – MZR Software"
        description="Optimize your infrastructure with MZR Software’s cloud and DevOps solutions."
        image="https://mzrsoftware.com/assets/images/og-clouddevops.jpg"
        url="https://mzrsoftware.com/OurServices/CloudDevOps/clouddevops"
      />

      <div className="cloud-devops-page">
        <section className="services-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">
                MZR <span className="highlight">Cloud & DevOps Solutions</span>
              </h2>
              <p className="section-subtitle">
                Secure, scalable, and automated infrastructure management for
                modern enterprise applications.
              </p>
            </div>

            <div className="services-grid">
              {cloudServices.map((service, index) => (
                <div
                  key={index}
                  className={`service-card zig-zag ${
                    index % 2 === 0 ? "left" : "right"
                  }`}
                >
                  <div className="card-content">
                    <span className={`bi ${service.icon} service-icon`}></span>
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                    <div className="service-features">
                      {service.features.map((feature, i) => (
                        <span key={i} className="feature-tag">
                          {feature}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="card-image">
                    <img src={service.img} alt={service.title} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default CloudDevOps;
